<template>
    <div v-if="id_pagamento_atendimento">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
            title="Integração Siga Call" id="integracao-sigacall-status-button" aria-haspopup="true"
            aria-expanded="false">
            SigaCall
        </button>

        <div class="dropdown-menu" aria-labelledby="integracao-sigacall-status-button">
            <a class="dropdown-item" href="#" @click="pagar()"> Pagar </a>
            
            <div v-for="item in itens_pagamento_atendimento" :key="item.id">
                <a class="dropdown-item" href="#" @click="logComunicacao(item.id_item_pagamento_atendimento)">
                    <i class="fa-solid fa-book fa-fw mr-2"></i>Log de Comunicação {{ item.forma_pagamento.search }}</a>
            </div>

        </div>

        <log-integracao-siga-call ref="logIntSigaCall" />
    </div>
</template>

<script>
import LogIntegracaoSigaCall from "../shared/audit/LogIntegracaoSigaCall.vue";

export default {
    data() {
        return {
            id_item_pagamento_atendimento: null,
            itens_pagamento_atendimento: [],
        };
    },

    props: {
        id_pagamento_atendimento: {
            type: Number,
            required: true,
        },
        marcacao: {
            type: Object,
            required: false,
        },
        id_unidade_operacao: {
            type: Number,
            required: false,
        },
    },

    components: {
        LogIntegracaoSigaCall
    },

    methods: {
        pagar() {
            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "sigacall_pagar_pagamento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento,
                },

                callback: (res) => {
                    if (!res.ok) {

                        this.$toast.add({
                            severity: "error",
                            summary: "Erro",
                            detail: res.body,
                            life: 6000,
                        });

                    } else {

                        this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: res.body,
                            life: 6000,
                        });

                    }

                    this.fecharModalRecepcao();
                },
            });
        },

        logComunicacao: function (id) {
            this.id_item_pagamento_atendimento = id;

            this.$refs.logIntSigaCall.abrir(
                "itemPagamentoAtendimento",
                id,
                true
            );
        },

        getItensPagamentoAtendimento() {
            this.$util.atualizar(this, {
                service: "atendimentos",
                func: "sigacall_get_itens_pagamento_atendimento",
                dados: {
                    id_pagamento_atendimento: this.id_pagamento_atendimento
                },
                callback: (res) => {
                    this.itens_pagamento_atendimento = res
                },
            });
        },
    },


    mounted() {
        this.getItensPagamentoAtendimento();
    },
};
</script>